import axios from 'axios';
import { getEnv } from '../../environment';

const altinnrolleApiUrl = getEnv('VUE_APP_ALTINNROLLE_API');
const driftsmeldingApi = getEnv('VUE_APP_DRIFTSMELDING_URL');
const eiendomsskattApi = getEnv('VUE_APP_EIENDOMSSKATT_URL');

const index = {
  getRepresentations() {
    return axios
      .get(`${altinnrolleApiUrl}/representasjoner`, { useBrukerinfo: true })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },

  getDriftsmeldinger(komponentId) {
    return axios
      .get(`${driftsmeldingApi}/driftsmeldinger/${komponentId}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },

  getSkatteperiodeId(skattear) {
    return axios
      .get(`${eiendomsskattApi}/skatteperiode/${skattear}`)
      .then((response) => response.data.id)
      .catch((error) => Promise.reject(error.response));
  },

  getSkatteiendommer(skatteperiodeId, indentitetId) {
    return axios
      .get(`${eiendomsskattApi}/skatt/skatteeiendommer/${skatteperiodeId}/${indentitetId}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },
};

export default index;
